export const Device = {
  Unknown: 0,
  LeftController: 1,
  RightController: 2,
};

export const Input = {
  Unknown: 0,
  Trigger: 1,
  TrackPad: 2,
  Grip: 3,
  ApplicationMenu: 4,
};

export default {
  Device,
  Input,
};
